export const abbreviationOfName = (str: string): string => {
  if (!str) {
    return ''
  }

  if (str.length > 14) {
    const newStr = str.slice(0, 14)
    return newStr + '...'
  }

  return str
}
